export const minBirthDate = (date: string) => {
  return new Date().getFullYear() - new Date(date).getFullYear() >= 16;
};

export const maxMinDateValidation = (date: string) => {
  return new Date().getFullYear() >= +date && +date >= new Date('01.01.1970').getFullYear();
};
